/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/home/pickup-week/pickup-week.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '../../../../../../public/upgrade/core/date.service';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/constants';
import * as import9 from '@angular/core/src/linker/component_factory';
import * as import10 from '../../../../../../public/upgrade/root/ga/ga.service';
import * as import11 from '@angular/router/src/router_state';
import * as import12 from '../../../../../../public/upgrade/feature/home/pickup-week/pickup-day/pickup-day.component';
import * as import13 from './pickup-day/pickup-day.component.ngfactory';
import * as import14 from '@angular/core/src/linker/view_container';
import * as import15 from '../../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import16 from '@ngx-translate/core/src/translate.pipe';
import * as import17 from '@angular/core/src/linker/template_ref';
import * as import18 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import19 from '@ngx-translate/core/src/translate.service';
import * as import20 from '@angular/common/src/directives/ng_for';
export class Wrapper_PickupWeekComponent {
  /*private*/ _eventHandler:Function;
  context:import0.PickupWeekComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  constructor(p0:any,p1:any,p2:any) {
    this._changed = false;
    this.context = new import0.PickupWeekComponent(p0,p1,p2);
    this._expr_0 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_pickupList(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.pickupList = currValue;
      this._expr_0 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_PickupWeekComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_PickupWeekComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.PickupWeekComponent>;
  _DateService_0_3:import6.DateService;
  _PickupWeekComponent_0_4:Wrapper_PickupWeekComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_PickupWeekComponent_Host0,renderType_PickupWeekComponent_Host,import7.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'pickup-week',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_PickupWeekComponent0(this.viewUtils,this,0,this._el_0);
    this._DateService_0_3 = new import6.DateService();
    this._PickupWeekComponent_0_4 = new Wrapper_PickupWeekComponent(this.injectorGet(import10.GAService,this.parentIndex),this.injectorGet(import11.ActivatedRoute,this.parentIndex),this._DateService_0_3);
    this.compView_0.create(this._PickupWeekComponent_0_4.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import9.ComponentRef_<any>(0,this,this._el_0,this._PickupWeekComponent_0_4.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import6.DateService) && (0 === requestNodeIndex))) { return this._DateService_0_3; }
    if (((token === import0.PickupWeekComponent) && (0 === requestNodeIndex))) { return this._PickupWeekComponent_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._PickupWeekComponent_0_4.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const PickupWeekComponentNgFactory:import9.ComponentFactory<import0.PickupWeekComponent> = new import9.ComponentFactory<import0.PickupWeekComponent>('pickup-week',View_PickupWeekComponent_Host0,import0.PickupWeekComponent);
const styles_PickupWeekComponent:any[] = ([] as any[]);
class View_PickupWeekComponent1 extends import2.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  compView_2:import2.AppView<import12.PickupDayComponent>;
  _PickupDayComponent_2_3:import13.Wrapper_PickupDayComponent;
  _text_3:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import14.ViewContainer) {
    super(View_PickupWeekComponent1,renderType_PickupWeekComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','col -lg-2 -md-6 -sm-12 -eva-3-mb-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'pickup-day',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_2 = new import13.View_PickupDayComponent0(this.viewUtils,this,2,this._el_2);
    this._PickupDayComponent_2_3 = new import13.Wrapper_PickupDayComponent();
    this.compView_2.create(this._PickupDayComponent_2_3.context);
    this._text_3 = this.renderer.createText(this._el_0,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_0));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import12.PickupDayComponent) && (2 === requestNodeIndex))) { return this._PickupDayComponent_2_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2_0_0:any = this.context.$implicit;
    this._PickupDayComponent_2_3.check_puDay(currVal_2_0_0,throwOnChange,false);
    const currVal_2_0_1:any = (this.context.$implicit == this.parentView.context.pickupList[0]);
    this._PickupDayComponent_2_3.check_isToday(currVal_2_0_1,throwOnChange,false);
    this._PickupDayComponent_2_3.ngDoCheck(this,this._el_2,throwOnChange);
    this.compView_2.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_2.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.routeReserveList(this.context.$implicit.day.asString)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_PickupWeekComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_PickupWeekComponent,{});
export class View_PickupWeekComponent0 extends import2.AppView<import0.PickupWeekComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  _anchor_8:any;
  /*private*/ _vc_8:import14.ViewContainer;
  _TemplateRef_8_5:any;
  _NgFor_8_6:import15.Wrapper_NgFor;
  _text_9:any;
  /*private*/ _expr_13:any;
  _pipe_translate_0:import16.TranslatePipe;
  /*private*/ _expr_15:any;
  _pipe_translate_1:import16.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_PickupWeekComponent0,renderType_PickupWeekComponent,import7.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_13 = import1.UNINITIALIZED;
    this._expr_15 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12 -eva-3-mt-lg -eva-3-mb-sm home-next-pickups'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'p',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'strong',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_7 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._anchor_8 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._vc_8 = new import14.ViewContainer(8,(null as any),this,this._anchor_8);
    this._TemplateRef_8_5 = new import17.TemplateRef_(this,8,this._anchor_8);
    this._NgFor_8_6 = new import15.Wrapper_NgFor(this._vc_8.vcRef,this._TemplateRef_8_5,this.parentView.injectorGet(import18.IterableDiffers,this.parentIndex),this.ref);
    this._text_9 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._pipe_translate_0 = new import16.TranslatePipe(this.parentView.injectorGet(import19.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import16.TranslatePipe(this.parentView.injectorGet(import19.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._text_7,
      this._anchor_8,
      this._text_9
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import17.TemplateRef) && (8 === requestNodeIndex))) { return this._TemplateRef_8_5; }
    if (((token === import20.NgFor) && (8 === requestNodeIndex))) { return this._NgFor_8_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_8_0_0:any = this.context.pickupList;
    this._NgFor_8_6.check_ngForOf(currVal_8_0_0,throwOnChange,false);
    this._NgFor_8_6.ngDoCheck(this,this._anchor_8,throwOnChange);
    this._vc_8.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_13:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_0.transform('home.NEXT_PU_1')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_13,currVal_13))) {
      this.renderer.setText(this._text_3,currVal_13);
      this._expr_13 = currVal_13;
    }
    valUnwrapper.reset();
    const currVal_15:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_1.transform('home.NEXT_PU_2')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_15,currVal_15))) {
      this.renderer.setText(this._text_5,currVal_15);
      this._expr_15 = currVal_15;
    }
  }
  destroyInternal():void {
    this._vc_8.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import2.AppView<any> {
    if ((nodeIndex == 8)) { return new View_PickupWeekComponent1(this.viewUtils,this,8,this._anchor_8,this._vc_8); }
    return (null as any);
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/home/pickup-week/pickup-week.component.ngfactory.ts